import { action, observable, runInAction } from 'mobx';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
class AlertStore {
  @observable exibir = false;
  @observable titulo = 'Atenção';
  @observable conteudo = '';
  callback;

  @action fecharAlert = () => {
    this.exibir = false;
    if (this.callback) this.callback();
  }

  @action abrirAlert = (titulo = this.titulo, conteudo, cb) => {
    runInAction(() => {
      this.exibir = true;
      this.titulo = titulo;
      this.conteudo = conteudo;
      this.callback = cb;
    });
  }
}

export default AlertStore;
